import BaseTableReport from 'components/atoms/base-table/report/report';
import { useTranslation } from 'react-i18next';
import { type FC } from 'react';
import { useActionTimeManagement } from 'infrastructure/hooks/action-time-management/use-data';
import { useActionTimeManagementFilters } from 'infrastructure/hooks/action-time-management/use-filter';

import { useColumns } from './columns';

import type { ActionTimeManagementItem } from 'infrastructure/hooks/action-time-management/types';

const ActionTimeManagementToolTable: FC = () => {
  const { data, isLoading } = useActionTimeManagement();
  const { filter, updateFilter } = useActionTimeManagementFilters();
  const { t } = useTranslation();
  const columns = useColumns({
    billingMonth: filter.billingMonth,
    billingYear: filter.billingYear,
    page: filter.page,
  });

  return (
    <BaseTableReport<ActionTimeManagementItem>
      rowKey={(record) => record.actionGuid + record.actionType}
      isLoading={isLoading}
      columns={columns}
      headerTitle={t('actionTimesManagement.actions')}
      dataSource={data.data}
      pagination={{
        current: filter.page,
        pageSize: filter.items,
        total: data.count,
        onChange: (page) => updateFilter({ page }),
      }}
      showCount
      anchor
    />
  );
};

export default ActionTimeManagementToolTable;
